import callApi, { CallApiResult } from 'src/api';

export const fetchUsersByQuery = (query: string): Promise<CallApiResult> => {
    if (query !== '') query = '?qry=' + query;
    const endpoint = `/api/admin/users${query}`;
    return callApi(endpoint);
};
